import React from 'react'
import {
  UserMinus,
  UserPlus as PhosphorUserPlus,
  Warning,
  Info as PhosphorInfo,
  Key as PhosphorKey,
  DownloadSimple,
  MagnifyingGlass,
  Funnel,
  Plus as PhosphorPlus,
  ArrowsCounterClockwise,
  Pencil,
  Trash,
  Eye as PhosphorEye,
  EyeSlash as PhosphorEyeSlash,
  UploadSimple,
  CurrencyDollar,
  Lock as PhosphorLock,
  UserCircle as PhosphorUserCircle,
  Question,
  User as PhosphorUser,
  SignOut,
  SidebarSimple,
  Buildings,
  Gear,
  ChartBar,
  UsersThree,
  House,
  Notebook,
  FloppyDisk,
  ChartLine,
  Newspaper as PhosphorNewspaper,
  CurrencyCircleDollar,
  CalendarBlank,
  Monitor as PhosphorMonitor,
  Flag as PhosphorFlag,
  Bank,
  Handshake as PhosphorHandshake,
  Certificate,
  LightbulbFilament,
  Package as PhosphorPackage,
  Envelope,
  Phone as PhosphorPhone,
  Clock as PhosphorClock,
  CheckCircle as PhosphorCheckCircle,
  XCircle as PhosphorXCircle,
  X as PhosphorX,
  Check as PhosphorCheck,
  PaperPlaneTilt,
  Copy as PhosphorCopy,
  DotsThreeVertical,
  DotsSixVertical,
  CreditCard as PhosphorCreditCard,
  WarningCircle,
  UserGear,
  ChartPieSlice,
  SignIn,
  GraduationCap as PhosphorGraduationCap,
  Wrench as PhosphorWrench,
  ShieldCheck as PhosphorShieldCheck,
  UserCheck as PhosphorUserCheck,
  CaretDown,
  CaretLeft,
  CaretUpDown,
  CaretRight,
  Heartbeat,
  PlugsConnected,
  Lightning as PhosphorLightning,
  ArrowSquareOut as PhosphorArrowSquareOut,
  TreeStructure as PhosphorTreeStructure,
  GearSix as PhosphorGearSix,
  BookOpenText as PhosphorBookOpenText,
  ChartLineUp as PhosphorChartLineUp,
  TestTube as PhosphorTestTube,
  Terminal as PhosphorTerminal,
  Star as PhosphorStar,
  ClipboardText as PhosphorClipboardText,
  Sparkle as PhosphorSparkle,
  Tag as PhosphorTag,
  Folder as PhosphorFolder,
  FolderOpen as PhosphorFolderOpen,
  FolderPlus as PhosphorFolderPlus,
  FileCode as PhosphorFileCode,
  FileMd as PhosphorFileMd,
  FilePy as PhosphorFilePy,
  FileSql as PhosphorFileSql,
  Article as PhosphorArticle,
} from '@phosphor-icons/react'

// Wrapper function to make Phosphor icons compatible with Lucide API
const createIconWrapper = (PhosphorIcon: any, displayName?: string) => {
  const Wrapper = React.forwardRef<SVGSVGElement, any>((props, ref) => {
    const { className, size, weight, ...rest } = props
    // Extract size from className (e.g., "w-4 h-4" -> 16, "w-5 h-5" -> 20)
    let iconSize = size || 24
    if (className) {
      if (className.includes('w-3') || className.includes('h-3')) iconSize = 12
      else if (className.includes('w-4') || className.includes('h-4')) iconSize = 16
      else if (className.includes('w-5') || className.includes('h-5')) iconSize = 20
      else if (className.includes('w-6') || className.includes('h-6')) iconSize = 24
      else if (className.includes('w-8') || className.includes('h-8')) iconSize = 32
    }
    return <PhosphorIcon ref={ref} size={iconSize} weight={weight || 'regular'} className={className} {...rest} />
  })

  if (displayName) {
    Wrapper.displayName = displayName
  }

  return Wrapper
}

// Export all wrapped icons with Lucide-compatible names
export const UserRoundX = createIconWrapper(UserMinus, 'UserRoundX')
export const UserPlus = createIconWrapper(PhosphorUserPlus, 'UserPlus')
export const AlertCircle = createIconWrapper(Warning, 'AlertCircle')
export const Info = createIconWrapper(PhosphorInfo, 'Info')
export const Key = createIconWrapper(PhosphorKey, 'Key')
export const Download = createIconWrapper(DownloadSimple, 'Download')
export const Search = createIconWrapper(MagnifyingGlass, 'Search')
export const Filter = createIconWrapper(Funnel, 'Filter')
export const Plus = createIconWrapper(PhosphorPlus, 'Plus')
export const RefreshCw = createIconWrapper(ArrowsCounterClockwise, 'RefreshCw')
export const Edit = createIconWrapper(Pencil, 'Edit')
export const Trash2 = createIconWrapper(Trash, 'Trash2')
export const Eye = createIconWrapper(PhosphorEye, 'Eye')
export const EyeSlash = createIconWrapper(PhosphorEyeSlash, 'EyeSlash')
export const Upload = createIconWrapper(UploadSimple, 'Upload')
export const DollarSign = createIconWrapper(CurrencyDollar, 'DollarSign')
export const Lock = createIconWrapper(PhosphorLock, 'Lock')
export const UserCircle = createIconWrapper(PhosphorUserCircle, 'UserCircle')
export const HelpCircle = createIconWrapper(Question, 'HelpCircle')
export const User = createIconWrapper(PhosphorUser, 'User')
export const LogOut = createIconWrapper(SignOut, 'LogOut')
export const PanelLeft = createIconWrapper(SidebarSimple, 'PanelLeft')
export const Building2 = createIconWrapper(Buildings, 'Building2')
export const Settings = createIconWrapper(Gear, 'Settings')
export const BarChart3 = createIconWrapper(ChartBar, 'BarChart3')
export const Users = createIconWrapper(UsersThree, 'Users')
export const Home = createIconWrapper(House, 'Home')
export const FileText = createIconWrapper(Notebook, 'FileText')
export const Save = createIconWrapper(FloppyDisk, 'Save')
export const TrendingUp = createIconWrapper(ChartLine, 'TrendingUp')
export const Newspaper = createIconWrapper(PhosphorNewspaper, 'Newspaper')
export const CircleDollarSign = createIconWrapper(CurrencyCircleDollar, 'CircleDollarSign')
export const Calendar = createIconWrapper(CalendarBlank, 'Calendar')
export const Monitor = createIconWrapper(PhosphorMonitor, 'Monitor')
export const Flag = createIconWrapper(PhosphorFlag, 'Flag')
export const Building = createIconWrapper(Bank, 'Building')
export const Handshake = createIconWrapper(PhosphorHandshake, 'Handshake')
export const Award = createIconWrapper(Certificate, 'Award')
export const Lightbulb = createIconWrapper(LightbulbFilament, 'Lightbulb')
export const Package = createIconWrapper(PhosphorPackage, 'Package')
export const Mail = createIconWrapper(Envelope, 'Mail')
export const Phone = createIconWrapper(PhosphorPhone, 'Phone')
export const Clock = createIconWrapper(PhosphorClock, 'Clock')
export const CheckCircle = createIconWrapper(PhosphorCheckCircle, 'CheckCircle')
export const XCircle = createIconWrapper(PhosphorXCircle, 'XCircle')
export const X = createIconWrapper(PhosphorX, 'X')
export const Check = createIconWrapper(PhosphorCheck, 'Check')
export const Send = createIconWrapper(PaperPlaneTilt, 'Send')
export const Copy = createIconWrapper(PhosphorCopy, 'Copy')
export const MoreHorizontal = createIconWrapper(DotsThreeVertical, 'MoreHorizontal')
export const GripVertical = createIconWrapper(DotsSixVertical, 'GripVertical')
export const CreditCard = createIconWrapper(PhosphorCreditCard, 'CreditCard')
export const AlertTriangle = createIconWrapper(WarningCircle, 'AlertTriangle')
export const UserCog = createIconWrapper(UserGear, 'UserCog')
export const ChartPie = createIconWrapper(ChartPieSlice, 'ChartPie')
export const LogIn = createIconWrapper(SignIn, 'LogIn')
export const GraduationCap = createIconWrapper(PhosphorGraduationCap, 'GraduationCap')
export const Wrench = createIconWrapper(PhosphorWrench, 'Wrench')
export const ShieldCheck = createIconWrapper(PhosphorShieldCheck, 'ShieldCheck')
export const UserCheck = createIconWrapper(PhosphorUserCheck, 'UserCheck')
export const ChevronDown = createIconWrapper(CaretDown, 'ChevronDown')
export const ChevronLeft = createIconWrapper(CaretLeft, 'ChevronLeft')
export const ChevronsUpDown = createIconWrapper(CaretUpDown, 'ChevronsUpDown')
export const ChevronRight = createIconWrapper(CaretRight, 'ChevronRight')
export const Activity = createIconWrapper(Heartbeat, 'Activity')
export const Integrations = createIconWrapper(PlugsConnected, 'Integrations')
export const Lightning = createIconWrapper(PhosphorLightning, 'Lightning')
export const ArrowSquareOut = createIconWrapper(PhosphorArrowSquareOut, 'ArrowSquareOut')
export const TreeStructure = createIconWrapper(PhosphorTreeStructure, 'TreeStructure')
export const GearSix = createIconWrapper(PhosphorGearSix, 'GearSix')
export const BookOpenText = createIconWrapper(PhosphorBookOpenText, 'BookOpenText')
export const ChartLineUp = createIconWrapper(PhosphorChartLineUp, 'ChartLineUp')
export const TestTube = createIconWrapper(PhosphorTestTube, 'TestTube')
export const TerminalIcon = createIconWrapper(PhosphorTerminal, 'TerminalIcon')
export const Star = createIconWrapper(PhosphorStar, 'Star')
export const ClipboardText = createIconWrapper(PhosphorClipboardText, 'ClipboardText')
export const SparkleIcon = createIconWrapper(PhosphorSparkle, 'SparkleIcon')
export const TagIcon = createIconWrapper(PhosphorTag, 'TagIcon')
export const FolderIcon = createIconWrapper(PhosphorFolder, 'FolderIcon')
export const FolderOpenIcon = createIconWrapper(PhosphorFolderOpen, 'FolderOpenIcon')
export const FolderPlusIcon = createIconWrapper(PhosphorFolderPlus, 'FolderPlusIcon')
export const FileCodeIcon = createIconWrapper(PhosphorFileCode, 'FileCodeIcon')
export const FileMdIcon = createIconWrapper(PhosphorFileMd, 'FileMdIcon')
export const FilePyIcon = createIconWrapper(PhosphorFilePy, 'FilePyIcon')
export const FileSqlIcon = createIconWrapper(PhosphorFileSql, 'FileSqlIcon')
export const ArticleIcon = createIconWrapper(PhosphorArticle, 'ArticleIcon')
